
export default {
  state: {
    // 属性
    additionList: []
  },
  getters: {
    additionList: state => state.additionList
  },
  mutations: {
    // set方法
    setAdditionList (state, v) {
      state.additionList = v
    }
  },
  actions: {
    SET_ADDITION_LIST ({ commit }, value) {
      commit('setAdditionList', value)
    }
  }
}
